import Vue from 'vue';
export default Vue.extend({
    name: 'returnTitle',
    data: function () {
        return {};
    },
    props: {
        titleConfig: {
            type: Object,
            default: function () {
                return {
                    backTitle: '',
                    currentTitle: '',
                    routerName: false,
                    name: '',
                    url: '',
                };
            },
        },
    },
    methods: {
        back: function () {
            var _a = this.titleConfig, routerName = _a.routerName, name = _a.name, url = _a.url;
            if (routerName) {
                this.$router.push({ name: name });
                return;
            }
            this.$router.push(url);
        },
    },
});
